import moment from 'moment';
import {
  isArray,
  isDefined,
  isStringDefined,
  isStringEmpty
} from '../../../utils/isDefined';
import { PROVIDERS_NUMBERS } from '../../../consts/initialValues';
import Optional from '../../../utils/optional';
import mapSubscriptionToOrderItem from './mapSubscriptionToOrderItem';

const mapDataForRequest = ({
  userData,
  client,
  template,
  loggedUserEmail,
  copiedUserDetails = {}
}) => {
  const data = { ...userData };
  let orderItems = [];

  const {
    first_name,
    last_name,
    notes,
    mobile_number,
    selected,
    landline_number,
    internal_number,
    email,
    department,
    custom_id,
    fields,
    cost_center,
    username,
    copied_user_id,
    ipad_support,
    premium_intrusion,
    premium_attendant,
    call_control_api,
    cloud_cti_api,
    line_state_api,
    crm_connect,
    unified_inbox,
    teams_telephony_go,
    teams_telephony,
    teams_application,
    chat,
    cloud_crm_connector,
    order_confirmation_email,
    account,
    language,
    groups,
    exchange_sync,
    exchange_id,
    call_recording
  } = data;

  const isSoftphone = mapAnswerPlaces(copiedUserDetails?.answer_places, 'SOFT');

  const mappedNotes = `${selected === 'new' ? 'Nyt nummer, ' : ''}${
    selected === 'port' ? 'Nummerportering, ' : ''
  }${call_recording === true ? ' Aktivér opkaldsoptagelse, ' : ''}${
    cloud_cti_api === true ? ' Aktivér Cloud CTI-API, ' : ''
  }${isStringDefined(notes) ? notes : ''}`;

  const userOrder = {
    action: 'add',
    identifier: 'TELEPO_USER',
    account: {
      id: account.id,
      name: account.name
    },
    account_reference: account.externalReference,
    product_offering: {
      first_name,
      last_name,
      mobile_number: isStringDefined(mobile_number)
        ? `+${mobile_number}`
        : null,
      mobile_will_be_ported: selected === 'port' ? true : false,
      landline_number: isStringDefined(landline_number)
        ? `+${landline_number}`
        : null,
      internal_number: isStringDefined(internal_number)
        ? internal_number
        : null,
      email,
      department,
      custom_id,
      dir_fields: mapFields(fields),
      cost_center,
      username,
      teams_application,
      teams_telephony_go,
      teams_telephony,
      chat,
      cloud_crm_connector,
      ipad_support,
      premium_intrusion,
      premium_attendant,
      call_control_api,
      cloud_cti_api,
      line_state_api,
      crm_connect,
      unified_inbox,
      contact_search: copiedUserDetails?.contact_search || false,
      mobile_voip: copiedUserDetails?.mobile_voip || false,
      web_softphone: copiedUserDetails?.web_softphone || false,
      user_profile: copiedUserDetails?.user_profile || null,
      language: language || copiedUserDetails?.language || null,
      license_type: copiedUserDetails?.user_license_type || null,
      user_groups: groups || copiedUserDetails?.user_groups || [],
      location: copiedUserDetails?.device_location_name || null,
      lync_phone: copiedUserDetails?.lync_phone || null,
      lync_presence: copiedUserDetails?.lync_presence || null,
      softphone: isSoftphone,
      copy_from_user: Optional(copiedUserDetails?.user_id).or(copied_user_id),
      e_trunk_destination_line:
        copiedUserDetails?.e_trunk_destination_line || null,
      exchange_sync,
      exchange_id:
        exchange_sync === true && isStringDefined(exchange_id)
          ? exchange_id
          : null
    },
    notes: mappedNotes,
    requester_email: loggedUserEmail
  };

  if (isDefined(order_confirmation_email)) {
    userOrder.order_confirmation_email = order_confirmation_email;
  }
  orderItems = [...orderItems, userOrder];
  if (isDefined(template)) {
    const subscriptionOrder = mapSubscriptionToOrderItem({
      template,
      client,
      data,
      mappedNotes
    });

    orderItems = [...orderItems, subscriptionOrder];
  }

  return {
    order_items: orderItems,
    related_party: {
      id: String(client.id),
      name: client.name
    }
  };
};

export default mapDataForRequest;

const mapFields = fields => {
  return fields.map(field => {
    const { value, id } = field;
    const mappedValue = isStringEmpty(value) ? null : value;
    return { id, value: mappedValue };
  });
};

const mapAnswerPlaces = (answerPlaces, key) => {
  if (!isArray(answerPlaces)) {
    return false;
  }
  const place = answerPlaces.find(place => place.type === key);

  return isDefined(place);
};
